/* Modulo — Product Feature.
   Native scroll-snap does the scrolling (works before this file loads → no CLS).
   JS wires: tab switching, per-rail arrows + sliding progress thumb, and the
   on-card variant pills (pick a size → update price + re-point the card link). */
(function () {
  'use strict';
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.__moduloPfLoaded) return;
  window.__moduloPfLoaded = true;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function stepSize(rail) {
    var card = rail.querySelector('.modulo-pf__card');
    if (!card) return rail.clientWidth * 0.8;
    var cs = getComputedStyle(rail);
    var gap = parseFloat(cs.columnGap || cs.gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function updateProgress(rail, thumb, rtl) {
    if (!thumb) return;
    var scrollW = rail.scrollWidth;
    var clientW = rail.clientWidth;
    var max = scrollW - clientW;
    var visible = scrollW > 0 ? clientW / scrollW : 1;
    var w = Math.max(0.12, Math.min(1, visible));
    var pct = max > 2 ? Math.abs(rail.scrollLeft) / max : 0;
    var tx = w < 1 ? pct * (1 - w) / w * 100 : 0;
    thumb.style.width = (w * 100) + '%';
    /* translateX is not direction-aware; thumb is anchored inset-inline-start, so
       in RTL it starts physical-right and must travel negative. */
    thumb.style.transform = 'translateX(' + (rtl ? -tx : tx) + '%)';
  }

  function updateArrows(rail, prev, next) {
    var max = rail.scrollWidth - rail.clientWidth;
    var pos = Math.abs(rail.scrollLeft);
    var active = document.activeElement;
    if (prev) prev.disabled = pos <= 2;
    if (next) next.disabled = pos >= max - 2;
    if (active === prev && prev.disabled && next && !next.disabled) next.focus();
    else if (active === next && next.disabled && prev && !prev.disabled) prev.focus();
  }

  function wireRail(rail) {
    if (rail.__pfRail) return;
    rail.__pfRail = true;
    var wrap = rail.closest('.modulo-pf__railwrap');
    var thumb = wrap ? wrap.querySelector('[data-pf-thumb]') : null;
    var prev = wrap ? wrap.querySelector('[data-pf-prev]') : null;
    var next = wrap ? wrap.querySelector('[data-pf-next]') : null;
    var rtl = getComputedStyle(rail).direction === 'rtl';

    function sync() { updateArrows(rail, prev, next); updateProgress(rail, thumb, rtl); }

    function page(dir) {
      var s = stepSize(rail);
      var per = Math.max(1, Math.floor(rail.clientWidth / s));
      rail.scrollBy({ left: dir * s * per * (rtl ? -1 : 1), behavior: REDUCE ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });

    var ticking = false;
    rail.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { sync(); ticking = false; });
    }, { passive: true });

    rail._pfSync = sync;
    sync();
  }

  function wireTabs(section) {
    var tabs = [].slice.call(section.querySelectorAll('[data-pf-tab]'));
    var panels = [].slice.call(section.querySelectorAll('[data-pf-panel]'));
    if (tabs.length < 2) return;

    function activate(tab, moveFocus) {
      var i = tab.getAttribute('data-pf-tab');
      for (var t = 0; t < tabs.length; t++) {
        var on = tabs[t] === tab;
        tabs[t].classList.toggle('is-active', on);
        tabs[t].setAttribute('aria-selected', on ? 'true' : 'false');
        tabs[t].tabIndex = on ? 0 : -1;
      }
      for (var p = 0; p < panels.length; p++) {
        var show = panels[p].getAttribute('data-pf-panel') === i;
        panels[p].classList.toggle('is-active', show);
        if (show) {
          panels[p].removeAttribute('hidden');
          var rail = panels[p].querySelector('[data-pf-rail]');
          if (rail && rail._pfSync) rail._pfSync();
        } else {
          panels[p].setAttribute('hidden', '');
        }
      }
      if (moveFocus) tab.focus();
    }

    for (var k = 0; k < tabs.length; k++) {
      (function (tab) {
        tab.addEventListener('click', function () { activate(tab, false); });
        tab.addEventListener('keydown', function (e) {
          var idx = tabs.indexOf(tab), n;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (idx + 1) % tabs.length;
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (idx - 1 + tabs.length) % tabs.length;
          else if (e.key === 'Home') n = 0;
          else if (e.key === 'End') n = tabs.length - 1;
          else return;
          e.preventDefault();
          activate(tabs[n], true);
        });
      })(tabs[k]);
    }
  }

  function wirePills(section) {
    if (section.__pfPills) return;
    section.__pfPills = true;
    section.addEventListener('click', function (e) {
      var pill = e.target.closest ? e.target.closest('[data-pf-pill]') : null;
      if (!pill || pill.disabled) return;
      var group = pill.closest('.modulo-pf__pills');
      if (!group) return;
      var siblings = group.querySelectorAll('[data-pf-pill]');
      for (var s = 0; s < siblings.length; s++) {
        siblings[s].classList.remove('is-active');
        siblings[s].setAttribute('aria-pressed', 'false');
      }
      pill.classList.add('is-active');
      pill.setAttribute('aria-pressed', 'true');
      var card = pill.closest('.modulo-pf__card');
      if (!card) return;
      var price = card.querySelector('[data-pf-price]');
      if (price && pill.dataset.price) price.textContent = pill.dataset.price;
      if (pill.dataset.url) {
        var links = card.querySelectorAll('.modulo-pf__cardlink');
        for (var l = 0; l < links.length; l++) links[l].setAttribute('href', pill.dataset.url);
      }
    });
  }

  function initSection(section) {
    if (section.__moduloPfInit) return;
    section.__moduloPfInit = true;
    var rails = section.querySelectorAll('[data-pf-rail]');
    for (var i = 0; i < rails.length; i++) wireRail(rails[i]);
    wireTabs(section);
    wirePills(section);
  }

  function boot(scope) {
    var els = (scope || document).querySelectorAll('[data-modulo-pf]');
    for (var i = 0; i < els.length; i++) initSection(els[i]);
  }

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var rails = document.querySelectorAll('[data-pf-rail]');
      for (var i = 0; i < rails.length; i++) {
        if (rails[i]._pfSync) rails[i]._pfSync();
      }
    }, 100);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
